<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="layout-directionality" [attr.layoutDirection]="LayoutDirection[layoutDirection]" fxLayoutAlign="start center">
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="space-between center">
    <!-- Presets -->
    <button
      class="task-date-filter-preset-menu"
      mat-button
      [matMenuTriggerFor]="taskDateFilterPresets"
    >
      <fa-icon class="icon" [icon]="faCalendarRange"></fa-icon>
      <span>{{ getTaskDateFilterPresetsLabel(currentPreset) }}</span>
      <fa-icon class="icon caret-icon" [icon]="faSortDown"></fa-icon>
    </button>

    <mat-menu #taskDateFilterPresets="matMenu" xPosition="before">
      <ng-template #filterPresetTemplate let-preset="preset">
        <button
          *ngIf="
            preset != TaskDateFilterPresets.custom ||
            currentPreset == TaskDateFilterPresets.custom
          "
          mat-menu-item
          (click)="onTaskDateFilterPresetClick(preset)"
        >
          <div class="task-date-filter-preset-item" fxLayout="row">
            <span>{{ getTaskDateFilterPresetsLabel(preset) }}</span>
            <fa-icon class="icon" *ngIf="currentPreset == preset" [icon]="faCheck"></fa-icon>
          </div>
        </button>
      </ng-template>

      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.lastSevenDays }"
      ></ng-container>
      <mat-divider></mat-divider>
      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.lastWeek }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.thisWeek }"
      ></ng-container>
      <!-- As we currently display tasks based on updatedAt, future date ranges don't make sense -->
      <!-- <ng-container [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.nextWeek }"></ng-container> -->
      <mat-divider></mat-divider>
      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.lastMonth }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.thisMonth }"
      ></ng-container>
      <!-- As we currently display tasks based on updatedAt, future date ranges don't make sense -->
      <!-- <ng-container [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.nextMonth }"></ng-container> -->
      <mat-divider *ngIf="currentPreset == TaskDateFilterPresets.custom"></mat-divider>
      <ng-container
        [ngTemplateOutlet]="filterPresetTemplate"
        [ngTemplateOutletContext]="{ preset: TaskDateFilterPresets.custom }"
      ></ng-container>
    </mat-menu>

    <!-- Collapse toggle -->
    <mat-slide-toggle *ngIf="collapsible" labelPosition="before" [hideIcon]="true" [checked]="open" color="primary" (change)="open = $event.checked" i18n="label for refine time period toggle@@refineTimePeriod">Refine time period</mat-slide-toggle>
  </div>

  <div *ngIf="!collapsible || (collapsible && open)">
    <!-- Date range picker -->
    <div *ngIf="!separateStartEnd" class="date-range-picker">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n="@@timeRange">Time range</mat-label>
        <mat-date-range-input [formGroup]="taskDateFilter" [rangePicker]="taskRange">
          <input
            matStartDate
            formControlName="startDate"
            placeholder="Start"
            i18n-placeholder="label for Start date picker@@start"
          />
          <input
            matEndDate
            formControlName="endDate"
            placeholder="End"
            i18n-placeholder="label for End date picker@@end"
            (dateChange)="onCustomTaskDateFilterPicked()"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="taskRange">
          <fa-icon matDatepickerToggleIcon [icon]="faCalendarRange"></fa-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #taskRange></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div *ngIf="separateStartEnd" class="separated-date-pickers" [formGroup]="taskDateFilter" fxLayout="column" fxLayoutAlign="start center">
      <!-- Start datetime -->
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <!-- Date picker -->
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="label for From date picker@@from">From</mat-label>
          <input
            matInput
            readonly
            [matDatepicker]="fromDatepicker"
            formControlName="startDate"
            (dateChange)="onCustomTaskDateFilterPicked()"
            type="text"
          />
          <mat-datepicker-toggle
            id="start_date_picker"
            matSuffix
            [for]="fromDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #fromDatepicker></mat-datepicker>
        </mat-form-field>

        <!-- Time picker -->
        <mat-form-field *ngIf="withTime" appearance="outline" subscriptSizing="dynamic" class="time-field">
          <mat-label class="capitalize" i18n="label for Time picker@@time">time</mat-label>
          <input
            matInput
            readonly
            [ngxTimepicker]="fromTimepicker"
            [format]="24"
            formControlName="startTime"
            type="text"
          />
          <ngx-material-timepicker
            id="start_time_picker"
            #fromTimepicker
            [format]="24"
            (closed)="onCustomTaskDateFilterPicked()"
          ></ngx-material-timepicker>
        </mat-form-field>
      </div>

      <!-- End datetime -->
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <!-- Date picker -->
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="label for To date picker@@to">To</mat-label>
          <input
            matInput
            readonly
            [matDatepicker]="toDatepicker"
            formControlName="endDate"
            (dateChange)="onCustomTaskDateFilterPicked()"
            type="text"
          />
          <mat-datepicker-toggle
            id="end_date_picker"
            matSuffix
            [for]="toDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #toDatepicker></mat-datepicker>
        </mat-form-field>

        <!-- Time picker -->
        <mat-form-field *ngIf="withTime" appearance="outline" subscriptSizing="dynamic" class="time-field">
          <mat-label class="capitalize" i18n="label for Time picker@@time">time</mat-label>
          <input
            matInput
            readonly
            [ngxTimepicker]="toTimepicker"
            [format]="24"
            formControlName="endTime"
            type="text"
          />
          <ngx-material-timepicker
            id="end_time_picker"
            #toTimepicker
            (closed)="onCustomTaskDateFilterPicked()"
          ></ngx-material-timepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
